// this function exists as a TS no-op to make the keys appear verbatim at least once in code for searchability
import { type BoothTab, BoothTabSection } from './BoothEnums.ts';

export const tabI18nKey = (
  tab: BoothTab,
): 'dealers:tab.all' | 'dealers:tab.bookmarks' | 'dealers:tab.world' => `dealers:tab.${tab}`;

export const sectionI18nKey = (
  section: BoothTabSection,
):
  | 'dealers:tab.section.avatar_bases'
  | 'dealers:tab.section.avatar_assets'
  | 'dealers:tab.section.avatar_services'
  | 'dealers:tab.section.2d_illustration'
  | 'dealers:tab.section.other'
  | 'dealers:tab.section.creative'
  | null => (section === BoothTabSection.ALL ? null : `dealers:tab.section.${section}`);
